const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://action.op.dianhun.cn/202106/market/public/index.php/api' : 'https://m3guo.17m3.com/202106/market/public/index.php/api';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:8081/' : 'https://www.m3guo.com/activity/202311/bazaar-134b3d8/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'index.html';

const activityTime = '2023.11.28-2023.12.14';

const ver = 20230727;

const getQueryVariable = function (variable) {
    var query = window.location.href.split("?")[1];
    var vars = query ? query.split("&") : [];

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1].split('#/bazaar')[0];
        }
    }
    return '';
}

const tipsImg = ['D774', 'D847', 'F468', 'KV34', 'X718', 'Y634','K295','K749','KB95','KW19','LF52','LJ34','KW18','MD96','MD97','MD98','J237','LY33','ML38','ML39','ML40','ML41','LE84','LF85','X622','X630','MV51','MV52','MV53','MV54',]

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const wx_share_text = {
  title: '【阿斗赶集】四大礼包、圆梦金镖、宠物卷、千万士兵...砍价就有！哥哥来帮帮阿斗吧~', // 分享标题
  desc: '好友帮砍价，好物带回家', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202302/adshop/sns.jpg', // 分享图标   
}

const ajax_url_map = {
    queryplayer: host + '/user/getM3gName', //游戏角色查询接口（需要大区id）
    freelogin: host + '/user/login/pocket', //口袋自登录验证
    login: host + '/user/login/login?callback=' + encodeURIComponent(domain), //login
    userinfo : host + '/user/getUserInfo', //查询角色信息
    bind: host + '/user/bind',//绑定大区
    goodslist : host + '/user/goodsList',//商品列表
    w12_goodslist : host + '/user/goodsTargetList',//双12特殊商品列表
    m3b : host + '/user/flushCoin',//刷新梦三币接口
    task : host + '/user/fuli',//福利
    share : host + '/user/shareInfo',//砍价
    add_basket : host + '/user/addBasket',//加入购物车(仅限不参与砍价的道具)
    acceptShare : host + '/user/acceptShare',//接受砍价
    basket : host + '/user/basket',//购物车
    buy : host + '/user/buy',//结算
    order : host + '/user/purchasedList',//已购买列表接口
    waitlist : host + '/user/unsharedList',//待砍价接口
    shop : host + '/user/shopOfferList',//店铺优惠券列表接口
    getfuli : host + '/user/getFuli',//领取福利
    tjl : host + '/user/checkTjl',//tjl
    settle : host + '/user/settle',//结算
    tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
}, {
  "id": 21,
  "name": "长生殿"
}, 
{
  "id": 22,
  "name": "逍遥津(wegame3)"
},{
  "id": 23,
  "name": "单刀赴会"
},
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const discountType = {
  1 : {
    parse : 2000,
    cut : 200
  },
  2 : {
    parse : 5000,
    cut : 600
  },
  0 : {
    parse : 0,
    cut : 0
  },  
}

const shopOfferType = {
  1 : {
    rate : 0.8,
    max : 2000,
    require : 8000,
  }
}

export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    ver,
    param,
    deviceType,
    areaList,
    discountType,
    shopOfferType,
    activityTime,
    tipsImg,
    wx_share_text,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js